import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDateFnsModule } from "@angular/material-date-fns-adapter";
import { CUSTOM_DATE_FORMATS } from "@app/components/material/matDatePicker/mat-date-picker.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
    imports: [
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatDateFnsModule,
        MatCheckboxModule,
        MatButtonModule,
    ],
    exports: [
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
    ],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ]
})
export class MaterialModule {

}
